import { Fragment, useEffect, useRef, useState } from "react";
import { RouteComponentProps } from "../../models/RouteComponent";
import { TabView, TabPanel } from "primereact/tabview";
import { Card } from "primereact/card";
import { InputText } from "primereact/inputtext";

import { Grid } from "@mui/material";
import { FormControl, FormLabel } from "@mui/joy";
import { Button } from "primereact/button";
import { Toast } from "primereact/toast";

import { InputTextarea } from "primereact/inputtextarea";
import DropdownApi from "../../components/DropdownApi";

import S3DocumentsUpload from "../../components/S3DocumentsUpload";

import ImageS3Upload from "../../components/ImageS3Upload";

import { Calendar } from "primereact/calendar";

import { updateEquipment } from "../../service/equipmentService";
import IntervalDropdown from "../../components/IntervalDropdown";
import EquipmentSiteTable from "./Equipment-Site-table";

import EquipmentChecklistTable from "./Equipment-checklist-table";
import EquipmentChecklistSubmissionTable from "./Equipment-checklist-submission-table";

export default function EquipmentView(props: RouteComponentProps) {
  const equipment = props.equipment || {};

  const [name, setName] = useState(equipment.name || "");
  const [description, setDescription] = useState(equipment.description || "");
  const [equipmentType, setEquipmentType] = useState(equipment.equipment_type || "");
  const [equipmentTypeObject, setEquipmentTypeObject] = useState<any>({});
  const [serialNumber, setSerialNumber] = useState(equipment.serial_number || "");
  const [price, setPrice] = useState(equipment.price || "");
  const [purchasedDate, setPurchasedDate] = useState(
    equipment.purchased_date ? new Date(equipment.purchased_date) : undefined
  );
  const [maintenanceValue, setMaintenanceValue] = useState(equipment?.maintenance_value || "");
  const [maintenanceInterval, setMaintenanceInterval] = useState(
    equipment?.maintenance_interval || ""
  );
  const [expectedLifeValue, setExpectedLifeValue] = useState(equipment?.expected_life_value || "");
  const [expectedLifeInterval, setExpectedLifeInterval] = useState(
    equipment?.expected_life_interval || ""
  );
  const [maintenanceDate, setMaintenanceDate] = useState(
    equipment.maintenance_start_date ? new Date(equipment.maintenance_start_date) : undefined
  );

  const [nextMaintenanceWindowDate, setNextMaintenanceWindowDate] = useState(
    equipment.next_maintenance_window ? new Date(equipment.next_maintenance_window) : undefined
  );
  const [expectedLifeWindow, setExpectedLifeWindow] = useState(
    equipment.expected_life_window ? new Date(equipment.expected_life_window) : undefined
  );

  const [photo, setPhoto] = useState("");
  const [loading, setLoading] = useState(equipment.name || false);
  const toast = useRef(null as any);

  const session = props?.session || {};

  const clientId = session.client_id;
  const s3Key = equipment?.s3_key || `equipment/${equipment.id}`;

  useEffect(() => {
    setMaintenanceValue(equipmentTypeObject?.maintenance_value);
    setMaintenanceInterval(equipmentTypeObject?.maintenance_interval);
    setExpectedLifeValue(equipmentTypeObject?.expected_life_value);
    setExpectedLifeInterval(equipmentTypeObject?.expected_life_interval);
  }, [equipmentType]);

  async function equipmentUpdate() {
    const updateObject: any = {
      name,
      description,
      equipment_type: equipmentType,
      serial_number: serialNumber,
      purchased_date: purchasedDate,
      maintenance_interval: maintenanceInterval,
      maintenance_value: maintenanceValue,
      expected_life_value: expectedLifeValue,
      expected_life_interval: expectedLifeInterval,
      maintenance_start_date: maintenanceDate,
      next_maintenance_window: nextMaintenanceWindowDate,
      expected_life_window: expectedLifeWindow,
      s3_key: s3Key,
    };
    if (price && price != "") {
      updateObject.price = price;
    }
    updateEquipment(updateObject, equipment.id).then((r: any) => {
      const updatedEquipment = r;
      if (!!updatedEquipment.next_maintenance_window) {
        setNextMaintenanceWindowDate(new Date(updatedEquipment.next_maintenance_window));
      }
      if (!!updatedEquipment.expected_life_window) {
        setExpectedLifeWindow(new Date(updatedEquipment.expected_life_window));
      }
      toast.current.show({
        severity: "success",
        summary: "Equipment Updated Successfully",
        life: 3000,
      });
    });
  }

  const record_id = equipment.id || "";

  return (
    <Fragment>
      <TabView>
        <TabPanel header="Equipment Details">
          <Card>
            <Grid container spacing={2}>
              <Grid item xs={4}>
                <FormControl>
                  <ImageS3Upload photo={photo} setPhoto={setPhoto} s3Key={s3Key} toast={toast} />
                </FormControl>
              </Grid>
              <Grid item xs={8}>
                <Grid container spacing={2}>
                  <Grid item xs={12}>
                    <FormControl sx={{ flexGrow: 1 }}>
                      <FormLabel>
                        Name<div style={{ color: "red" }}>*</div>
                      </FormLabel>
                      <FormControl
                        sx={{
                          display: { sm: "flex-column", md: "flex-row" },
                          gap: 2,
                        }}
                      >
                        <InputText
                          value={name}
                          onChange={e => setName(e.target.value)}
                          type="text"
                          className="p-inputtext-sm PrimeSmallInput"
                        />
                      </FormControl>
                    </FormControl>
                  </Grid>
                  <Grid item xs={12}>
                    <FormControl>
                      <FormLabel>Serial Number</FormLabel>
                      <InputText
                        value={serialNumber}
                        onChange={e => setSerialNumber(e.target.value)}
                        type="text"
                        className="p-inputtext-sm PrimeSmallInput"
                      />
                    </FormControl>
                  </Grid>
                </Grid>
              </Grid>
              <br />
              <Grid item xs={12}>
                <FormControl>
                  <FormLabel>Unique ID</FormLabel>
                  <FormControl
                    sx={{
                      display: { sm: "flex-column", md: "flex-row" },
                      gap: 2,
                    }}
                  >
                    <InputTextarea
                      value={description}
                      placeholder="Unique ID"
                      onChange={e => setDescription(e.target.value)}
                    />
                  </FormControl>
                </FormControl>
              </Grid>
              <br />
              <Grid item xs={6}>
                <DropdownApi
                  apiPath="equipment-type"
                  optionLabel="name"
                  optionValue="id"
                  label="Equipment Type"
                  selectedData={equipmentType}
                  setSelectedData={setEquipmentType}
                  setSelectedObject={setEquipmentTypeObject}
                />
              </Grid>
              <br />
              <Grid item xs={6}>
                <FormControl sx={{ flexGrow: 1 }}>
                  <FormLabel>Price</FormLabel>
                  <InputText
                    value={price}
                    onChange={e => setPrice(e.target.value)}
                    type="number"
                    className="p-inputtext-sm PrimeSmallInput"
                  />
                </FormControl>
              </Grid>
            </Grid>
          </Card>
        </TabPanel>
        <TabPanel header="Maintenance">
          <Card>
            <Grid container spacing={2}>
              <Grid item xs={6}>
                <FormControl>
                  <FormLabel>Purchased Date</FormLabel>
                  <Calendar
                    dateFormat="yy-mm-dd"
                    value={purchasedDate}
                    onChange={e => setPurchasedDate(e.value || new Date())}
                    showIcon
                  />
                </FormControl>
              </Grid>
              <Grid item xs={6}>
                <IntervalDropdown
                  label="Expected Life"
                  selectedInterval={expectedLifeInterval || equipment?.expected_life_interval || ""}
                  setSelectedInterval={setExpectedLifeInterval}
                  selectedValue={expectedLifeValue || equipment?.expected_life_value || ""}
                  setSelectedValue={setExpectedLifeValue}
                />
              </Grid>
              <Grid item xs={6}>
                <FormControl>
                  <FormLabel>Last Maintenance Date</FormLabel>
                  <Calendar
                    dateFormat="yy-mm-dd"
                    value={maintenanceDate}
                    onChange={e => setMaintenanceDate(e.value || new Date())}
                    showIcon
                  />
                </FormControl>
              </Grid>
              <Grid item xs={6}>
                <IntervalDropdown
                  label="Maintenance"
                  selectedInterval={maintenanceInterval || equipment?.maintenance_interval || ""}
                  setSelectedInterval={setMaintenanceInterval}
                  selectedValue={maintenanceValue || equipment?.maintenance_value || ""}
                  setSelectedValue={setMaintenanceValue}
                />
              </Grid>
              {equipment?.maintenance_start_date && (
                <Grid item xs={6}>
                  <FormControl>
                    <FormLabel>Next Maintenance Window</FormLabel>
                    <Calendar
                      dateFormat="yy-mm-dd"
                      value={nextMaintenanceWindowDate}
                      onChange={e => setNextMaintenanceWindowDate(e.value || new Date())}
                      showIcon
                    />
                  </FormControl>
                </Grid>
              )}
              {equipment?.expected_life_window && (
                <Grid item xs={6}>
                  <FormControl>
                    <FormLabel>Expected Replacement Date</FormLabel>
                    <Calendar
                      dateFormat="yy-mm-dd"
                      value={expectedLifeWindow}
                      onChange={e => setExpectedLifeWindow(e.value || new Date())}
                      showIcon
                    />
                  </FormControl>
                </Grid>
              )}
            </Grid>
          </Card>
        </TabPanel>
        <TabPanel header="Sites">
          <EquipmentSiteTable
            globalLoader={props.globalLoader}
            breadcrumbs={props.breadcrumbs}
            session={props.session}
            setBreadcrumbs={props.setBreadcrumbs}
            setGlobalLoader={props.setGlobalLoader}
            setSession={props.setSession}
            accessLevel={props.accessLevel}
            equipment={equipment}
            setAccessLevel={props.setAccessLevel}
            setEmployee={props.setEmployee}
          />
        </TabPanel>
        <TabPanel header="Checklist">
          <EquipmentChecklistTable
            setGlobalLoader={props.setGlobalLoader}
            record_id={record_id}
            client_id={clientId}
            props={props}
          />
        </TabPanel>
        <TabPanel header="Checklist Submissions">
          <EquipmentChecklistSubmissionTable
            setGlobalLoader={props.setGlobalLoader}
            record_id={record_id}
            client_id={clientId}
            props={props}
          />
        </TabPanel>
        <TabPanel header="Documents">
          <S3DocumentsUpload
            setGlobalLoader={props.setGlobalLoader}
            record_id={record_id}
            client_id={clientId}
            type="equipment"
            props={props}
          />
        </TabPanel>
        {/* <TabPanel header="Risk">
          <RiskAssessmentComponent
            setGlobalLoader={props.setGlobalLoader}
            record_id={record_id}
            client_id={clientId}
            type="Equipment"
            props={props}
          />
        </TabPanel> */}
      </TabView>
      <Button
        type="button"
        icon="pi pi-save"
        label="Save"
        className="p-button-outlined"
        size="small"
        style={{
          position: "absolute",
          fontSize: "small",
          right: 70,
          top: 75,
          color: "#2dd36f",
        }}
        onClick={() => equipmentUpdate()}
      />

      <Toast ref={toast} />
    </Fragment>
  );
}
